export { default } from './CustomerMainLayout';
